import React, { useEffect, useState } from 'react';
import { Check, ChevronsUpDown } from "lucide-react";
import { cn } from "../../../Lib/utils.js";
import { Button } from "../../ui/button";   
import {
  Command,
  CommandEmpty,
  CommandGroup,
  CommandInput,
  CommandItem,
  CommandList,
} from "../../ui/command";
import { Popover, PopoverContent, PopoverTrigger } from "../../ui/popover";
import { getAllProfesoresByStatus } from "../../../provider/adm/profesores/teachersByStatus";

const ScrollListProfesores = ({ 
  profesorSelectedToFilter, 
  setprofesorSelectedToFilter, 
  setLoading, 
  setTeacherID,
  multiSelect = false
}) => {
  const [open, setOpen] = useState(false);
  const [listaProfesores, setlistaProfesores] = useState([]);
  
  // Función mejorada para comparar nombres ignorando espacios extras
  const compareNames = (name1, name2) => {
    if (!name1 || !name2) return false;
    // Normalizar: trim + convertir espacios múltiples a uno solo + lowercase para comparación
    const normalize = (str) => str.trim().replace(/\s+/g, ' ').toLowerCase();
    return normalize(name1) === normalize(name2);
  };

  // Normalizar selectedProfesors para que siempre sea consistente
  const selectedProfesors = multiSelect 
    ? Array.isArray(profesorSelectedToFilter) 
      ? profesorSelectedToFilter 
      : profesorSelectedToFilter ? [profesorSelectedToFilter] : []
    : profesorSelectedToFilter;
  
  useEffect(() => {
    const fetchFrameworks = async () => {
      try {
        const profesores = await getAllProfesoresByStatus(true);
        setlistaProfesores(profesores || []);
      } catch (error) {
        setlistaProfesores([]);
      } 
    };
    
    fetchFrameworks();
  }, [setLoading]);

  // Helper function to handle selection based on mode
  const handleSelect = (currentValue, profesorId) => {
    if (multiSelect) {
      const currentSelection = Array.isArray(profesorSelectedToFilter) 
        ? profesorSelectedToFilter 
        : profesorSelectedToFilter ? [profesorSelectedToFilter] : [];
        
      // Buscar si ya está seleccionado usando comparación mejorada
      const isAlreadySelected = currentSelection.some(selected => 
        compareNames(selected, currentValue)
      );
      
      if (isAlreadySelected) {
        // Remove if already selected - usar comparación mejorada
        const newSelection = currentSelection.filter(name => 
          !compareNames(name, currentValue)
        );
        setprofesorSelectedToFilter(newSelection);
      } else {
        // Add to selection
        const newSelection = [...currentSelection, currentValue];
        setprofesorSelectedToFilter(newSelection);
      }
    } else {
      // Original single select behavior - usar comparación mejorada
      const newValue = compareNames(currentValue, profesorSelectedToFilter) ? "" : currentValue;
      setprofesorSelectedToFilter(newValue);
      if (setTeacherID) {
        setTeacherID(newValue ? profesorId : null);
      }
      setOpen(false);
    }
  };

  // Agregar useEffect para monitorear cambios en la selección
  useEffect(() => {
    // Efecto mantenido para compatibilidad
  }, [profesorSelectedToFilter, selectedProfesors, multiSelect]);

  const getDisplayText = () => {
    if (multiSelect) {
      if (Array.isArray(selectedProfesors) && selectedProfesors.length > 0) {
        return `${selectedProfesors.length} profesores seleccionados`;
      }
      return "Selecciona profesores...";
    } else {
      if (profesorSelectedToFilter) {
        // Buscar el profesor usando comparación mejorada
        const found = listaProfesores.find((framework) => 
          compareNames(framework.fullName, profesorSelectedToFilter)
        );
        
        if (found) {
          return found.fullName;
        } else {
          // Si no se encuentra, mostrar el valor seleccionado directamente
          return profesorSelectedToFilter;
        }
      }
      return "Selecciona profesor...";
    }
  };

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger>
        <Button
          variant="outline"
          role="combobox"
          type="button" 
          className="w-[200px] justify-between"
          onClick={(event) => {   
            event.preventDefault();
            event.stopPropagation();
            setOpen(!open);
          }}
        >
          {getDisplayText()}
          <ChevronsUpDown className="opacity-50" />
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-[200px] p-0">
        <Command>
          <CommandInput
            placeholder="Buscar profesor..."
            className="h-9"
          />
          <CommandList>
            <CommandEmpty>No se encontraron profesores.</CommandEmpty>
            <CommandGroup>
              {listaProfesores.map((framework) => (
                <CommandItem
                  key={framework.id}
                  value={framework.fullName}
                  onSelect={(currentValue) => {
                    handleSelect(currentValue, framework.id);
                  }}
                  className="flex items-center"
                >
                  {multiSelect && (
                    <input 
                      type="checkbox" 
                      checked={Array.isArray(selectedProfesors) && selectedProfesors.some(selected => 
                        compareNames(selected, framework.fullName)
                      )} 
                      onChange={() => {}} 
                      className="h-4 w-4 mr-2"
                    />
                  )}
                  {framework.fullName}
                  {!multiSelect && (
                    <Check
                      className={cn(
                        "ml-auto",
                        compareNames(profesorSelectedToFilter, framework.fullName)
                          ? "opacity-100"
                          : "opacity-0"
                      )}
                    />
                  )}
                </CommandItem>
              ))}
            </CommandGroup>
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
};

export default ScrollListProfesores;